import { SecurityConfig } from '../types'
import { redirectCookieKey } from '../config'

// We chose to use cookies to save the redirect url in order to make the
// saved redirect expire when the user closes the browser in case we forget
// to remove it.
//
//

const saveRedirect = (
  location: Partial<Location>,
  securityConfig: SecurityConfig
) => {
  const locationJson = JSON.stringify({
    pathname: location.pathname,
    search: location.search,
  })

  if (location.search || location.pathname !== securityConfig.successPath) {
    try {
      sessionStorage.setItem(redirectCookieKey, locationJson)
    } catch (e) {}
  }
}

const getRedirect = (): Location => {
  try {
    return JSON.parse(sessionStorage.getItem(redirectCookieKey))
  } catch (e) {}
}

const deleteRedirect = () => {
  try {
    sessionStorage.removeItem(redirectCookieKey)
  } catch (e) {}
}

export default {
  saveRedirect,
  getRedirect,
  deleteRedirect,
}
